import React, { useState, useEffect } from "react";
import { Button, CircularProgress, Typography } from "@material-ui/core";
import useStyles from "./styles";
import axios from "axios";
import { useDispatch } from "react-redux";
import { customerLoginSuccess } from "../../../redux/customer/customerActions";
import SolidButton from "../../../components/buttons/SolidButton";
import OtpInput from "react-otp-input";
import { rowFlexJustifyBetween } from "../../../styles/common";

const OTPVerifyForm = ({ mobile, onSuccess, onSubmit }) => {
  const classes = useStyles();
  const [progress, setProgress] = useState(5);
  const [resend, setResend] = useState(0);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setProgress(30);
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress <= 0) {
          clearInterval(timer);
        }
        return prevProgress - 1;
      });
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [resend]);

  const handleSubmit = (otp) => {
    onSubmit(mobile, otp)
      .then((response) => {
        dispatch(customerLoginSuccess(response.data));
        onSuccess();
      })
      .catch(() => {
        setOtpError(true);
      });
  };

  const getOTP = async () => {
    let response = await axios.post(
      `${process.env.REACT_APP_AUTH_API}/api/v1/auth/oauth/otp-customer`,
      `${mobile}`,
      {
        headers: {
          "Content-Type": "text/plain",
          "X-Requested-With": "XMLHttpRequest",
          Authorization: `Bearer ${process.env.REACT_APP_TRUSTED_TOKEN}`,
        },
      }
    );
    setResend(resend + 1);
    return response.data;
  };

  return (
    <div className={classes.form}>
      <OtpInput
        value={otp}
        onChange={(otp) => {
          setOtp(otp);
          if (otp.length === 4) handleSubmit(otp);
        }}
        numInputs={4}
        separator={<span></span>}
        containerStyle={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
        shouldAutoFocus
        isInputNum
        inputStyle={classes.otpItem}
      />
      <div
        className={rowFlexJustifyBetween}
        style={{ marginTop: 40, marginRight: 40 }}
      >
        {resend > 2 ? (
          <Typography component="p" variant="p">
            Resend limits exceeded
          </Typography>
        ) : (
          <>
            <div>
              <Typography variant="subtitle1" className={classes.errorText}>
                {otpError ? "INVALID OTP" : ""}
              </Typography>
            </div>
            <div>
              <Button
                onClick={getOTP}
                disabled={progress > 0}
                color="secondary"
                tabIndex={-1}
                className={classes.resend}
              >
                {progress > 0 && (
                  <CircularProgress
                    variant="determinate"
                    color="secondary"
                    value={progress / 0.3}
                    size={12}
                  />
                )}
                &nbsp; SEND AGAIN
              </Button>
            </div>
          </>
        )}
      </div>
      <SolidButton style={{ width: "100%" }} disabled={otp.length < 4}>
        Sign In
        {/*newAcc ? "Sign Up" : "Sign In"*/}
      </SolidButton>
    </div>
  );
};

export default OTPVerifyForm;
